// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPageLoadingIndicator_root__eGwEb"};